import { ContentLibraryOpenedFile } from 'features/content-library/types';

export const isContentLibraryMediaPlayer = (openedFile: ContentLibraryOpenedFile) => {
  const mediaTypes = ['youtube', 'vimeo', 'video', 'audio'];

  return mediaTypes.includes(openedFile.type);
};
